import { useEffect } from 'react'
import { trackWithExtra } from '../../../lib/tracking'
import { PageContainer } from '../../components'
import FreeThemePostForm from '../../components/forms/FreeThemePostForm'
import type { BargainUserInfo, Shop, Theme } from '../../types'

interface FreeThemePostFormPageProps {
  selected_theme: Theme
  bargain_user_info: BargainUserInfo
  myarea_shops: Shop[]
  current_theme?: Theme
}

const FreeThemePostFormPage: React.FC<FreeThemePostFormPageProps> = ({
  selected_theme,
  bargain_user_info,
  myarea_shops,
  current_theme,
}) => {
  useEffect(() => {
    void trackWithExtra('bargain.message_board.post.form.imp', {
      path: location.pathname,
    })
  }, [])

  return (
    <PageContainer maxWidth="640px">
      <FreeThemePostForm
        theme={selected_theme}
        bargain_user_info={bargain_user_info}
        myarea_shops={myarea_shops}
        currentTheme={current_theme}
      />
    </PageContainer>
  )
}

export default FreeThemePostFormPage
